module.exports = __webpack_public_path__ + "media/images/country-flags-europe-flag-spain-es-28c6a118ded827dca34b6bafcb0eab0c.svg";